import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import CustomButtonCancel from "./CustomButtonCancel";
import CustomButtonSave from "./CustomButtonSave";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { SelectInput } from "react-admin";
import sendRequest from "../dataProvider/sendRequest";
import useNotify from "./useNotify";

const CustomCancelTaskIcon = ({ ...props }) => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const color = props?.color || "red";
  const size = props?.size || "22px";
  let disabled = props?.disabled || false;
  const type = props?.type || "";
  const fileSrc = "/public/icon/action-delete.svg";
  const [open, setOpen] = useState(false);
  const [cancelStatus, setCancelStatus] = useState("");

  const handleCancelTask = () => {
    if (type == "DISBURSEMENT" || type == "DEPOSIT") {
      if (!cancelStatus) {
        errorNotify("Please select status of this transfer");
        return;
      }
    }
    var reqUrl = `task/actions/cancel`;
    sendRequest(reqUrl, {
      id: props?.id,
      data: { status: cancelStatus, type: props?.type },
    }).then((response) => {
      if (response && response.code == "200") {
        successNotify("Data cancel successfully");
        setOpen(false);
        if (props?.onClick) {
          props.onClick();
        }
      } else {
        errorNotify("Data can't cancel");
      }
    });
  };
  //如果时间before 3:45pm Eastern Time， disabled 可以是true, 否则是false
  const currentTime = new Date();
  const easternTimeOffset = -5 * 60; // Eastern Time is UTC-5
  const easternTime = new Date(
    currentTime.getTime() + easternTimeOffset * 60 * 1000
  );
  const cancelTime = new Date(
    easternTime.getFullYear(),
    easternTime.getMonth(),
    easternTime.getDate(),
    15,
    45
  ); // 3:45 PM Eastern Time
  if (currentTime > cancelTime) {
    //disabled = true;
  }

  if (disabled) {
    return (
      <Tooltip title={"Cannot cancel after 3:45 PM ET"} placement="left" arrow>
        <IconButton disabled={true}>
          <RemoveCircleOutlineIcon
            style={{
              width: size,
              height: size,
              color: "grey",
            }}
          />
        </IconButton>
      </Tooltip>
    );
  }
  return (
    <>
      <Tooltip title={props?.label || "Cancel"} placement="left" arrow>
        <IconButton onClick={() => setOpen(true)}>
          <RemoveCircleOutlineIcon
            style={{
              width: size,
              height: size,
              color: color,
            }}
          />
        </IconButton>
      </Tooltip>
      <Dialog
        fullWidth={true}
        maxWidth="sm"
        sx={{
          "& .MuiDialog-paper": {
            minHeight: type == "DISBURSEMENT" ? "45vh" : "auto",
          },
        }}
        open={open}
        onClose={() => setOpen(false)}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            borderBottom: "1px solid #e5e5e5",
            color: "#465384",
            textTransform: "uppercase",
          }}
        >
          Cancel Payment
        </DialogTitle>
        <DialogContent>
          <Typography
            component="div"
            variant="body1"
            sx={{ mt: "20px", mb: "20px" }}
          >
            {(type == "REPAYMENT" || type == "DISBURSEMENT") && (
              <>
                Click “Confirm” to cancel this ACH transaction. Please note:
                <ul>
                  <li>
                    Automatic Repayment ACH will be temporarily canceled and
                    initiated automatically the next day unless its payment due
                    date on the payment schedule has changed.
                  </li>
                  <li>
                    Borrower initiated Repayment ACH will be permanently
                    canceled and can be initiated again by the borrower
                    manually.
                  </li>
                  <li>
                    Disbursement ACH will be permanently cancelled and can be
                    initiated again by the lender manually.
                  </li>
                </ul>
              </>
            )}
          </Typography>
          {(type == "DISBURSEMENT" || type == "DEPOSIT") && (
            <>
              <SelectInput
                source="status"
                variant="outlined"
                label="Please specify status of this transfer"
                choices={[
                  {
                    id: "complete",
                    name: "Cancel permanently. This transfer has been made offline.",
                  },
                  {
                    id: "notcomplete",
                    name: "Cancel temporarily. Make this transfer at a later date.",
                  },
                ]}
                onChange={(e) => setCancelStatus(e.target.value)}
                value={cancelStatus}
                fullWidth
                sx={{ mb: "20px" }}
              />
            </>
          )}
          {(type == "REFUND" || type == "REFILL") && (
            <>
              Click “Confirm” to cancel this ACH transaction. Please note:
              <ul>
                <li>Automatic {type} ACH will be temporarily canceled.</li>
              </ul>
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={() => setOpen(false)} label="Cancel" />
          <CustomButtonSave onClick={handleCancelTask} label="Confirm" />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CustomCancelTaskIcon;
